export default __webpack_public_path__ + "static/media/qs-dropdown.240516cc.webp";